import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf05347"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/swiper_placeholder.png",
  alt: ""
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/swiper_placeholder.png",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/swiper_placeholder.png",
  alt: ""
}, null, -1))
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Login")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_ion_header, { collapse: "condense" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_title, { size: "large" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Willkommen")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_swiper, {
              modules: _ctx.modules,
              "slides-per-view": 1,
              "space-between": 50,
              pagination: {
              clickable: true 
              }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createTextVNode(" ... ")
              ]),
              _: 1
            }, 8, ["modules"]),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.otpSendCode()), ["prevent"]))
            }, [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createElementVNode("p", {
                    class: "prefix",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNameModal()))
                  }, [
                    _createVNode(_component_ion_avatar, null, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: _ctx.countryFlag,
                          alt: ""
                        }, null, 8, _hoisted_4)
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ion_note, { style: {"margin":"0 .4em 0 1em"} }, {
                    default: _withCtx(() => [
                      _createTextVNode(" +" + _toDisplayString(_ctx.countryPrefix), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    type: "tel",
                    placeholder: "Telefon Nummer",
                    modelValue: _ctx.loginPhoneNumber,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginPhoneNumber) = $event)),
                    class: "",
                    ref: "autofocus"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("p", {
                class: _normalizeClass(_ctx.formState.type)
              }, _toDisplayString(_ctx.formState.content), 3),
              _createVNode(_component_ion_button, {
                disabled: _ctx.loginPhoneNumber.length < 9,
                type: "submit",
                expand: "block",
                color: "primary",
                class: "ion-margin"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("SMS Code Senden")
                ]),
                _: 1
              }, 8, ["disabled"])
            ], 32)
          ]),
          _createVNode(_component_ion_loading, {
            "is-open": _ctx.loadingState.formSubmission,
            cssClass: "my-custom-class",
            message: "Please wait..."
          }, null, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}